module.exports = __webpack_public_path__ + "img/prescription-delete-item.2b7cfb40.svg";